import Vue from 'vue';
import {
  setInteractionMode,
  ValidationProvider,
  ValidationObserver
} from 'vee-validate';
import './locale';
import './rules';

setInteractionMode('aggressive');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
